import React from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Testimonal = () => {
  const testimonialData = [
    {
      name: 'Praveen BE CSE',
      college: 'Mount Zion 2021',
      job: 'TCS - Java Developer',
      text: 'The trainer not only guide me with the course but also they help us how to face Technical and Personal Interviews. That helped with a good placement.',
      image: 'assets/img/students/1.jpg',
    },
    {
        name: 'Raja Sakthivel BE CSE',
        college: 'Mount Zion 2021',
        job: 'TCS - Java Developer',
        text: 'Dolor et eos labore, stet justo sed est sed. Diam sed sed dolor stet amet eirmod eos labore diam',
        image: 'assets/img/students/2.jpg',
      },
      {
        name: 'Ganesan',
        college: '-',
        job: 'Student',
        text: ' Dolor et eos labore, stet justo sed est sed. Diam sed sed dolor stet amet eirmod eos labore diam',
        image: 'assets/img/students/3.jpg',
      },
      {
        name: 'Rakesh Raja',
        college: '-',
        job: 'Student',
        text: ' i was completed Hardware and Networking Course @ Acrosys That Gives me lot of things to learn about Computer Hardware and Networking',
        image: 'assets/img/students/4.jpg',
      },
      {
        name: 'Roshan BE CSE',
        college: '-',
        job: 'Student',
        text: '   Dolor et eos labore, stet justo sed est sed. Diam sed sed dolor stet amet eirmod eos labore diam',
        image: 'assets/img/testimonial-3.jpg',
      },
      {
        name: 'John Mathew BCA',
        college: 'Ananda College',
        job: '(Final Year) Student',
        text: 'I Joined Full Stack Java Developer Course with my 2 friends.it was excellent Learning.',
        image: 'assets/img/testimonial-4.jpg',
      },
      {
        name: 'Vaishali',
        college: 'Software Developer',
        job: 'Cts, Chennai',
        text: ' I Joined Core Java Course.it was excellent Learning.',
        image: 'assets/img/testimonial-4.jpg',
      },
      {
        name: 'Surya',
        college: 'BCA',
        job: 'Free Lancer',
        text: 'I Joined Photoshop Course.The Training was very good, i learned a lot from here.',
        image: 'assets/img/testimonial-4.jpg',
      }
      ,
      {
        name: 'Jeremiah',
        college: 'BCA',
        job: 'Free Lancer',
        text: 'I Joined Photoshop Course.The Training was very good, i learned a lot from here.',
        image: 'assets/img/testimonial-4.jpg',
      }

    // Add more testimonial data here...
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,         // Enable autoplay
    autoplaySpeed: 2000,   // Time between slides in milliseconds (e.g., 3000 ms or 3 seconds)
  };

  return (
    <div>
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="section-title text-center position-relative pb-3 mb-4 mx-auto">
            <h5 className="fw-bold text-primary text-uppercase">Testimonial</h5>
            <h1 className="mb-0">What Our Students Say About Our Courses</h1>
          </div>
          <Slider {...settings}>
            {testimonialData.map((testimonial, index) => (
              <div key={index} className="testimonial-item bg-light my-4">
                <div className="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                  <img className="img-fluid rounded" src={testimonial.image}  alt={testimonial.name} />
                  <div className="ps-4">
                    <h4 className="text-primary mb-1">{testimonial.name}</h4>
                    <small className="text-uppercase">{testimonial.college}</small>
                    <br />
                    <small className="text-uppercase">{testimonial.job}</small>
                  </div>
                </div>
                <div className="pt-4 pb-5 px-5">{testimonial.text}</div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonal